/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pkl_New_Lot_Supplier_LabelInputs */

const vi_pkl_new_lot_supplier_label = /** @type {(inputs: Pkl_New_Lot_Supplier_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhà cung cấp`)
};

/**

* @param {Pkl_New_Lot_Supplier_LabelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pkl_new_lot_supplier_label = /** @type {((inputs?: Pkl_New_Lot_Supplier_LabelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pkl_New_Lot_Supplier_LabelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pkl_new_lot_supplier_label(inputs)
});